import React, { useRef, useState, useEffect } from 'react'; //import React Component
import { useParams } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { cloudStore } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export function Detail() {
    // Get current check card
    const params = useParams();
    const rawNameString = params.cardName;
    let proname = (rawNameString).replace('%20', " ");

    const [cardData, setcardData] = useState([])
    useEffect(() => {
        getDocs(query(collection(cloudStore, "productData"), where("Product_Information.proname", "==", proname)))
            .then((querySnapshot) => {
                const proData = querySnapshot.docs.map((doc) => doc.data());
                setcardData(proData)
            })
    }, []);

    const [brand, setbrand] = useState("")
    const [pic, setpic] = useState("")
    const prointro = useRef(null)
    const [proprice, setproprice] = useState("")
    const [tag, settag] = useState("")
    const [LeftNum, setLeftNum] = useState("")
    const [OnFire, setOnFire] = useState("")
    const [Earn, setEarn] = useState("")
    const [SellNum, setSellNum] = useState("")
    const [SellPeople, setSellPeople] = useState("")

    const [ifoffShelves, setifoffShelves] = useState(false)
    useEffect(() => {
        if (cardData.length > 0) {
            setifoffShelves(cardData[0].offShelves)
            // console.log(cardData[0].Product_Information.prointro)
            setbrand(cardData[0].Product_Information.brand)
            setpic(cardData[0].Product_Information.pic)
            prointro.current = cardData[0].Product_Information.prointro
            setproprice(cardData[0].Product_Information.proprice)
            settag(cardData[0].Product_Information.tag)
            setLeftNum(cardData[0].LeftNum)
            setOnFire(cardData[0].OnFire.toString())
            setEarn(cardData[0].Earn)
            setSellNum(cardData[0].SellNum)
            setSellPeople(cardData[0].SellPeople)
        }
    }, [cardData])

    const [ifOfficer, setifOfficer] = useState(false)
    const 这个是二级保证 = localStorage.getItem("这个是二级保证");
    let userID = localStorage.getItem("currentLoginUserID");
    const [userData, setuserData] = useState([])
    useEffect(() => {
        if (ifOfficer === false && userID !== null) {
            getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.userID", "==", userID)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setuserData(data)
                })
            if (userData.length > 0) {
                if (userData[0].officer === true) {
                    setifOfficer(true)
                }
            }
        }
    });

    const addItem = (e) => {
        const cartItems = JSON.parse(sessionStorage.getItem("WhatInCart"));
        const array = [...new Set(cartItems)];
        const record = array.sort().reduce((acc, currentItem) => {
            const count = cartItems.filter(item => item === currentItem).length;
            acc.push({ [currentItem]: count });
            return acc;
        }, []);
        sessionStorage.setItem("forStock", JSON.stringify(record))

        const clickedButton = e.target
        let forStock = JSON.parse(sessionStorage.getItem("forStock")).filter((content) => {
            return Object.keys(content).some((key) => key === proname);
        })
        let forStocknum = 0
        if (forStock.length > 0) {
            forStocknum = forStock[0][proname]
        }

        if (forStocknum + 1 > LeftNum) {
            console.log("达到库存上限")
            var tips = document.getElementById("snackbar");
            tips.className = "show";
            setTimeout(() => { tips.className = tips.className.replace("show", "disappearFade"); }, 2000);
        } else {
            clickedButton.style.backgroundColor = "#b1dce9"
            clickedButton.textContent = 'Add';
            setTimeout(() => { clickedButton.style.backgroundColor = "white" }, 500);
            setTimeout(() => { clickedButton.textContent = 'add_shopping_cart'; }, 500);

            if (proname.length > 0) {
                if (sessionStorage.getItem("WhatInCart")) {
                    let array = JSON.parse(sessionStorage.getItem("WhatInCart"));
                    array.push(proname);
                    sessionStorage.setItem("WhatInCart", JSON.stringify(array));
                } else {
                    sessionStorage.setItem("WhatInCart", JSON.stringify([proname]));
                }
            }

            const cartUpdateEvent = new CustomEvent("cartUpdated");
            window.dispatchEvent(cartUpdateEvent);
        }
    }
    console.log(这个是二级保证)
    return (
        <div id="detail_page">
            <Navigation />

            {ifoffShelves === true && 这个是二级保证 === null ?
                <>
                    <main>
                        <div style={{ textAlign: "center", fontSize: "40px" }}>此商品已下架</div>
                    </main>
                </> : null
            }
            {ifoffShelves === false || ifOfficer === true ?
                <>
                    <main>
                        <div className='basic_info'>
                            <div>
                                <img
                                    src={pic}
                                    alt="pro_img"
                                />
                            </div>
                            <div>
                                <h1>{proname}</h1>
                                <h2>品牌：{brand}</h2>
                                <h2>食品类型：{tag}</h2>
                                <h2>价格：{proprice}$</h2>
                                <h2>剩余：{LeftNum}件</h2>
                            </div>
                            <div id="snackbar">抱歉，已达库存上限。</div>
                        </div>
                        <div className='intro'>
                            <h2>介绍：</h2>
                            <p style={{ whiteSpace: "pre-wrap" }}>{prointro.current}</p>
                        </div>

                        {ifOfficer === true && 这个是二级保证 === "true" ?
                            <>
                                <div className='intro'>
                                    <h3>Onfire：{OnFire}</h3>
                                    <h3>卖出数量：{SellNum}</h3>
                                    <h3>购买人数：{SellPeople}</h3>
                                    <h3>总收入：{Earn}</h3>
                                </div>
                            </> : null

                        }
                        {ifOfficer === false ?
                            <>
                            </> : null

                        }
                    </main>
                    <div
                        className='button material-symbols-outlined detailcartbutton'
                        style={{ animation: "none" }}
                        onClick={(e) => addItem(e)}>
                        add_shopping_cart
                    </div>
                </> : null
            }
            <Footer />
        </div>
    );
}